import controller from './category-products.controller';
import templateT1 from './templates/category-products-t1.view.html';
import templateAD from './templates/category-products-adaptative.html';

let CategoryComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        pageName:'@',
        search:'@'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative){
      return templateAD;
    } else {    
        return templateT1;
    }
}

export default CategoryComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/category/category-products/category-products.component.js
 **/